import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { cx } from 'emotion';
import { persimmon } from './colors';
import { useMemoizedId } from './utils';
const isSelectionTruthy = value => !((Array.isArray(value) && !value.length) || (value === null || value === undefined || value === ''));
const noop = () => { };
const SelectWrapper = props => {
    const { value, containerClassName, placeholder, label, selectedSelect, required, helpText, onBlurResetsInput, status, onBlur = noop, onFocus = noop, id, } = props;
    const [shouldFloat, setShouldFloat] = useState(value);
    const labelId = useMemoizedId({ label: 'react-select', id });
    const handleFocus = () => {
        setShouldFloat(true);
        onFocus();
    };
    const handleBlur = event => {
        const target = event && event.target;
        if ((onBlurResetsInput === false && target && target.value) || isSelectionTruthy(value)) {
            setShouldFloat(true);
        }
        else {
            setShouldFloat(false);
        }
        onBlur();
    };
    const handleInputKeyDown = searchInput => {
        if (searchInput !== '') {
            setShouldFloat(true);
        }
    };
    useEffect(() => {
        setShouldFloat(isSelectionTruthy(value));
    }, [value]);
    const className = cx('react-select-wrapper form-group', containerClassName, { 'form-group-active': shouldFloat });
    const helpTextClassName = status === 'error' ? 'text-danger' : `text-${status}`;
    return (React.createElement("div", { className: className },
        React.createElement("label", { htmlFor: labelId, style: { pointerEvents: 'none', wordWrap: 'break-word', width: '80%', lineHeight: '20px' }, className: 'control-label', title: placeholder || label },
            placeholder || label,
            required ? React.createElement("span", { style: { color: persimmon.base } }, " *") : ''),
        React.createElement(selectedSelect, Object.assign(Object.assign({}, props), { inputId: labelId, onFocus: handleFocus, onBlur: handleBlur, onInputChange: handleInputKeyDown, placeholder: '' })),
        helpText ? React.createElement("small", { className: helpTextClassName }, helpText) : null));
};
SelectWrapper.propTypes = {
    containerClassName: PropTypes.string,
    required: PropTypes.bool,
    selectedSelect: PropTypes.func,
    label: PropTypes.node,
    placeholder: PropTypes.node,
    value: PropTypes.any,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    helpText: PropTypes.node,
    onBlurResetsInput: PropTypes.bool,
    status: PropTypes.oneOf(['success', 'warning', 'error']),
    id: PropTypes.string,
};
export default SelectWrapper;
